/* eslint camelcase: 0 */
import api, { rawClient } from '../api';
import {
    DetailedTransactionSnapshot,
    StatementFetchParams,
    TransactionSnapshot,
    BalanceSnapshot,
    ScheduleDigestSnapshot,
} from '../../models/Banking';
import { ExportFormat } from '../../constants/file';
import { TransactionType } from '../../constants/banking';
import { getBackVersion } from '../../config';

type StatementResponse = {
    after: string | null;
    transactions: TransactionSnapshot[];
};

const serializeParams = (params: StatementFetchParams) => ({
    date_le: params.maxDate,
    date_ge: params.minDate,
    description: params.description || undefined,
    timestamp_gt: params.timestamp,
    effect: params.effect,
});

export const getStatement = (
    params: StatementFetchParams,
    page?: string
): Promise<StatementResponse> => {
    return api.request<StatementResponse>({
        method: 'GET',
        url: `${getBackVersion()}/banking/statement`,
        params: {
            page,
            count: 100,
            ...serializeParams(params),
        },
    });
};

export const downloadStatement = (
    params: StatementFetchParams,
    extension: ExportFormat
): Promise<void> => {
    const strParams = Object.entries(serializeParams(params))
        .filter(([_, val]) => val !== undefined)
        .map(([key, val]) => `${key}=${val}`)
        .join('&');
    return rawClient.download({
        url: `${getBackVersion()}/banking/statement/${extension}?${strParams}`,
    });
};

export const getDetailedTransaction = (
    sourceId: string,
    transactionType: TransactionType
): Promise<DetailedTransactionSnapshot> => {
    return api.request<DetailedTransactionSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/statement/${sourceId}/${transactionType}/details`,
    });
};

export const downloadTransactionPdf = (
    sourceId: string,
    transactionType: TransactionType
): Promise<void> => {
    return rawClient.download({
        url: `${getBackVersion()}/banking/statement/${sourceId}/${transactionType}/pdf`,
    });
};

export const getBalance = (): Promise<BalanceSnapshot> => {
    return api.request<BalanceSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/statement/balance`,
    });
};

export const getScheduleDigest = (): Promise<ScheduleDigestSnapshot> => {
    return api.request<ScheduleDigestSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/statement/schedule_digest`,
    });
};
